"use client";

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import BusinessDetailsStep from "./BusinessDetailsStep";
import DirectorsStep from "./DirectorsStep";
import ReviewSubmitStep from "./ReviewSubmitStep";

const steps = [
  { id: 1, label: "Business details" },
  { id: 2, label: "Directors" },
  { id: 3, label: "Review & Submit" },
];

export default function KYBFlow() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    businessName: "",
    tradingName: "",
    businessType: "",
    registrationNumber: "",
    taxNumber: "",
    industrySector: "",
    websiteUrl: "",
    businessAddress: "",
    directors: [],
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  const updateFormData = (fields) => {
    setFormData((prev) => ({ ...prev, ...fields }));
  };

  const handleNext = () => {
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (currentStep === 1) {
      navigate(-1);
    } else {
      setCurrentStep(currentStep - 1);
    }
  };

  const goToStep = (step) => {
    setCurrentStep(step);
  };

  return (
    <div className="bg-white min-h-screen flex flex-col">
      {/* Top Nav Bar */}
      <div className="border-b border-[#ebe9ef] flex items-center justify-between px-10 lg:px-20 py-8 h-[112px]">
        <div className="flex items-center justify-center w-[248px]">
          <p className="text-[20px] font-semibold leading-[24px] text-[#33125f] text-center whitespace-nowrap">
            Apply for business account
          </p>
        </div>

        <button
          onClick={() => logout && logout()}
          className="flex items-center gap-2 h-[48px] px-6 border border-[#ebe9ef] rounded-full text-[14px] font-semibold text-[#6d6584] hover:bg-gray-50 transition"
        >
          Log out
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 3.5L3.5 12.5M3.5 3.5L12.5 12.5"
              stroke="#6d6584"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Stepper */}
      <div className="flex items-center justify-center px-6 lg:px-[100px] py-4 mt-4">
        <div className="flex items-center gap-0 w-full max-w-[805px]">
          {steps.map((step, index) => {
            const isActive = step.id === currentStep;
            const isCompleted = step.id < currentStep;

            return (
              <React.Fragment key={step.id}>
                <div className="flex items-center justify-center gap-4 px-6 py-4 flex-1">
                  {isCompleted ? (
                    <div className="flex items-center justify-center w-[20px] h-[20px] bg-[#33125f] rounded-full shrink-0">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.5 6L5 8.5L9.5 3.5"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  ) : (
                    <span
                      className={`text-[14px] font-medium leading-[20px] ${
                        isActive ? "text-[#33125f]" : "text-[#abb7c2]"
                      }`}
                    >
                      {step.id}
                    </span>
                  )}
                  <span
                    className={`text-[14px] font-medium leading-[20px] whitespace-nowrap ${
                      isActive || isCompleted
                        ? "text-[#33125f]"
                        : "text-[#abb7c2]"
                    }`}
                  >
                    {step.label}
                  </span>
                </div>
                {index < steps.length - 1 && (
                  <div className="w-[40px] mx-2 border-t border-[#CFD6DC] rotate-[-60deg] origin-center shrink-0" />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>

      {/* Step Content */}
      <div className="flex-grow flex justify-center px-6">
        <div className="w-full max-w-[628px]">
          {currentStep === 1 && (
            <BusinessDetailsStep
              formData={formData}
              updateFormData={updateFormData}
              onNext={handleNext}
              onBack={handleBack}
            />
          )}

          {currentStep === 2 && (
            <DirectorsStep
              formData={formData}
              updateFormData={updateFormData}
              onNext={handleNext}
              onBack={handleBack}
            />
          )}

          {currentStep === 3 && (
            <ReviewSubmitStep
              formData={formData}
              onBack={handleBack}
              goToStep={goToStep}
              onSubmitSuccess={() => {
                navigate("/trading/digitalWallet?tab=business-account");
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
